import { render, staticRenderFns } from "./ModalViewDetailBahanPacking.vue?vue&type=template&id=6c517332&scoped=true&"
import script from "./ModalViewDetailBahanPacking.vue?vue&type=script&lang=js&"
export * from "./ModalViewDetailBahanPacking.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewDetailBahanPacking.vue?vue&type=style&index=0&id=6c517332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c517332",
  null
  
)

export default component.exports